import { SimpleLiquiditySource } from './simple-liquidity-source';
import { SimpleToken } from './simple-token';

export class Fill {
  public liquiditySource: SimpleLiquiditySource;
  public proportionInBps: number;
  public from: SimpleToken;
  public to: SimpleToken;
  public subFills: Fill[];
}
